import React, { useMemo } from 'react';
import { usePageTitle } from '../../hooks';
import { useWikiTypes } from '../../contexts/WikiTypesContext';
import WikiCategoryGrid, { CategoryItem } from './components/WikiCategoryGrid';
import WikiBreadcrumbs from './components/WikiBreadcrumbs';
import WikiSearch from './components/WikiSearch';
import GlassContainer from '../../components/layout/GlassContainer';
import { resolveApiSource } from '../../utils/wikiSourceResolver';

/**
 * Главная страница Wiki - карточки категорий + глобальный поиск (GET /wiki/search, без фильтра source).
 * Клик по результату открывает карточку в боковой панели (см. WikiSearch). Адрес /wiki.
 */
const WikiMainPage: React.FC = () => {
  usePageTitle('wiki');
  const { categories } = useWikiTypes();

  const categoryItems = useMemo((): CategoryItem[] => {
    return categories.map(cat => {
      const apiSource = resolveApiSource([cat.source]);
      return {
        id: cat.id,
        name: cat.name,
        source: cat.source,
        path: `/wiki/${apiSource}`,
      };
    });
  }, [categories]);

  return (
    <GlassContainer sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <WikiSearch breadcrumbs={<WikiBreadcrumbs />}>
        <WikiCategoryGrid categories={categoryItems} />
      </WikiSearch>
    </GlassContainer>
  );
};

export default WikiMainPage;
